import React from 'react';
import EventOptionsContainer from './../../../Containers/AdminContainer/EventOptions/index';

const EventOptionsScreen = () => {
  return <EventOptionsContainer />;
};

export default EventOptionsScreen;
